import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DeviceProcess from "../../../components/deviceProcess";
import { stationApi, deviceApi } from "@api/newApi";
import InspectionApi from "@api/inspectionnew";
import { Button, Descriptions, Modal, Table, Row, Col, DatePicker } from "antd";
import moment from "moment";
import RenderTxt from "@components/renderTxt";
const { RangePicker } = DatePicker;

const Pages = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const startTime =
    moment().subtract(1, "months").format("YYYY-MM-DD") + " 00:00:00";
  const endTime = moment().format("YYYY-MM-DD") + " 23:59:59";
  const [time, setTime] = useState([moment().subtract(1, "months"), moment()]);
  const [processData, setProcessData] = useState({});
  const [deviceInfo, setDeviceInfo] = useState({});
  const [tableDataSource, setTableDataSource] = useState({});
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [taskItems, setTaskItems] = useState([]);
  const [searchParams, setSearchParams] = useState({
    startTime,
    endTime,
    deviceId: "",
    pageNum: 1,
    pageSize: 10,
  });

  const columns = [
    {
      title: "任务",
      dataIndex: "name",
      align: "center",
      key: "name",
      render: (text) => RenderTxt(text),
    },
    {
      title: "巡检人",
      dataIndex: "handleUserName",
      align: "center",
      key: "handleUserName",
      render: (text) => RenderTxt(text),
    },
    {
      title: "状态",
      dataIndex: "statusName",
      align: "center",
      key: "statusName",
      render: (text) => RenderTxt(text),
    },
    {
      title: "时间",
      dataIndex: "beginTime",
      align: "center",
      key: "beginTime",
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <Button type="primary" onClick={() => getTaskInfo(obj)}>
            详情
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    if (searchParams.deviceId) {
      getPatrolMapTaskGroup();
    }
  }, [searchParams]);

  useEffect(() => {
    getProceess();
  }, []);

  const getProceess = () => {
    stationApi.findDeviceFlow(stationId).then((res) => {
      if (res.status !== "0") return;
      setProcessData(res.data);
    });
  };

  const getItem = ({ id }) => {
    setSearchParams({
      deviceId: id,
      startTime,
      endTime,
      pageNum: 1,
      pageSize: 10,
    });
    getDeviceInfo(id);
  };

  const getPatrolMapTaskGroup = () => {
    setLoading(true);
    InspectionApi.getPatrolMapTaskGroup({ ...searchParams, stationId }).then(
      (res) => {
        setLoading(false);
        if (res.status !== "0") return;
        const { data } = res.data;
        data &&
          data.map((item) => {
            item.key = item.id;
          });
        setTableDataSource(res.data);
      }
    );
  };

  const getDeviceInfo = (id) => {
    deviceApi.getById({ deviceId: id, stationId }).then((res) => {
      if (res.status !== "0") return;
      setDeviceInfo(res.data);
    });
  };

  const getTaskInfo = ({ id }) => {
    InspectionApi.getPatrolMapTaskItems({
      deviceId: searchParams.deviceId,
      taskGroupId: id,
      stationId,
    }).then((res) => {
      if (res.status !== "0") return;
      setTaskItems(res.data);
      setVisible(true);
    });
  };

  const handleTableChange = (pagination) => {
    setSearchParams({
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const reset = () => {
    setTime([moment(startTime), moment(endTime)]);
    setSearchParams({
      startTime,
      endTime,
      deviceId: searchParams.deviceId,
      pageNum: 1,
      pageSize: 10,
    });
  };

  const search = () => {
    setSearchParams({
      ...searchParams,
      pageNum: 1,
      pageSize: 10,
      startTime: time[0].format("YYYY-MM-DD") + " 00:00:00",
      endTime: time[1].format("YYYY-MM-DD") + " 23:59:59",
    });
  };

  return (
    <div
      className="inspectionnew-map"
      style={{ padding: 10, display: "flex", backgroundColor: "#fff" }}
    >
      <div style={{ minWidth: 545 }}>
        <DeviceProcess data={processData} getItem={getItem} />
      </div>
      <div style={{ flex: 1, marginLeft: 50 }}>
        <Descriptions title="设备信息">
          <Descriptions.Item label="物料类型">
            {deviceInfo.materielName}
          </Descriptions.Item>
          <Descriptions.Item label="所在场站">
            {deviceInfo.stationName}
          </Descriptions.Item>
          <Descriptions.Item label="设备型号">
            {deviceInfo.deviceModel}
          </Descriptions.Item>
          <Descriptions.Item label="所在工艺">
            {deviceInfo.processunitName}
          </Descriptions.Item>
          <Descriptions.Item label="设备规格">
            {deviceInfo.dossierSpec}
          </Descriptions.Item>
          <Descriptions.Item label="使用时间">
            {deviceInfo.insTime}
          </Descriptions.Item>
          <Descriptions.Item label="生产厂家">
            {deviceInfo.deviceFactory}
          </Descriptions.Item>
          <Descriptions.Item label="维保周期">
            {deviceInfo.maintenanceCycle}月
          </Descriptions.Item>
        </Descriptions>
        <div
          className="task-container"
          style={{ borderTop: "1px solid #ddd", paddingTop: 20 }}
        >
          <h3>巡检任务</h3>
          <Row gutter={20} style={{ marginTop: 20 }}>
            <Col span={8}>
              <Row>
                <Col span={4}>时间</Col>
                <Col span={20}>
                  <RangePicker value={time} onChange={(e) => setTime(e)} />
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Button onClick={reset}>重置</Button>
              <Button
                type="primary"
                style={{ marginLeft: 10 }}
                onClick={search}
              >
                搜索
              </Button>
            </Col>
          </Row>
          <Table
            columns={columns}
            dataSource={tableDataSource.data}
            pagination={{
              current: tableDataSource.pageNum,
              pageSize: tableDataSource.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (total) => `共${total}条数据`,
              total: tableDataSource.total,
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
      </div>
      <Modal
        open={visible}
        onCancel={() => setVisible(false)}
        onOk={() => setVisible(false)}
        title="任务信息"
        width={800}
      >
        <Row>
          {taskItems.map((item, index) => (
            <Col span={24} style={{ marginBottom: 20 }}>
              <h4>巡检项{index + 1}</h4>
              <Row gutter={20}>
                <Col span={4}>巡检内容</Col>
                <Col span={8}>{item.itemContent}</Col>
                <Col span={4}>是否正常</Col>
                <Col span={8}>{item.isNormal ? item.isNormal : "-"}</Col>
              </Row>
            </Col>
          ))}
        </Row>
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
